import produce from 'immer';

const replaceID = (collection, id) =>
  produce(collection, draft => {
    draft.forEach(item => {
      item.link = item.link.replace('ID', id);
    });
  });

export default replaceID;



// WEBPACK FOOTER //
// ./src/utility/replaceID.js